export const fadeIn = {
	hidden: {
		opacity: 0,
	},
	show: {
		opacity: 1,
		transition: {
			duration: 0.75,
		},
	},
	exit: {
		opacity: 1,
		transition: {
			duration: 0.75,
		},
	},
};
